export const GalleryImages = [

    {
        id: 1,
        url: 'p1.webp',
        thumbnail: 'p1-thumbnail.webp',
        caption: 'Yoga for Wellness: Embracing Health and Balance'
    },
    {
        id: 2,
        url: 'p2.webp',
        thumbnail: 'p2-thumbnail.webp',
        caption: 'Unleashing Potential: Sports Day in Action'
    },
    {
        id: 3,
        url: 'p3.webp',
        thumbnail: 'p3-thumbnail.webp',
        caption: 'Learning Beyond Classrooms: Educational Trip Adventures'
    },
    {
        id: 4,
        url: 'p4.webp',
        thumbnail: 'p4-thumbnail.webp',
        caption: 'Starting the Day with Positivity & Discipline'
    },
    {
        id: 5,
        url: 'p5.webp',
        thumbnail: 'p5-thumbnail.webp',
        caption: 'Healthy Habits Start Young: Exercise Session'
    },
    {
        id: 6,
        url: 'p6.webp',
        thumbnail: 'p6-thumbnail.webp',
        caption: 'Nurturing Nature: Tree Plantation Drive' 
    },
    {
        id: 7,
        url: 'p7.webp',
        thumbnail: 'p7-thumbnail.webp',
        caption :'Morning Assembly & Prayers'
    },
    {
        id: 8,
        url: 'p8.webp',
        thumbnail: 'p8-thumbnail.webp',
        caption :'Joyful Moments: Janmashtami & Dahi Handi Celebration'
    },
    {
        id: 9,
        url: 'p9.webp',
        thumbnail: 'p9-thumbnail.webp',
        caption :'Celebrating Excellence: Honoring Our Guests at the Annual Gathering'
    },
    {
        id: 10,
        url: 'p10.webp',
        thumbnail: 'p10-thumbnail.webp',
        caption: 'Inspiring Words from Dr. Sachin S. Jadhav at the Annual Event'
    },
    {
        id: 12,
        url: 'p12.webp',
        thumbnail: 'p12-thumbnail.webp',
        caption: 'Highlights from the Annual Gathering'
    },
    {
        id: 13,
        url: 'p13.webp',
        thumbnail: 'p13-thumbnail.webp',
        caption: 'Expressing Gratitude Through Felicitation'
    },
    {
        id: 14,
        url: 'p14.webp',
        thumbnail: 'p14-thumbnail.webp',
        caption: 'Extending a Warm Welcome to Our Guests'
    },
    {
        id: 15,
        url: 'p15.webp',
        thumbnail: 'p15-thumbnail.webp',
        caption: 'Honoring Our Esteemed Guests'
    },
    {
        id: 16,
        url: 'p16.webp',
        thumbnail: 'p16-thumbnail.webp',
        caption: 'Respect and Gratitude: Welcoming Our Guests'
    },
    {
        id: 11,
        url: 'p11.webp',
        thumbnail: 'p11-thumbnail.webp',
        caption: 'Inspiring Words from Dr. Sachin S. Jadhav at the Annual Event'
    },
    {
        id: 17,
        url: 'p17.webp',
        thumbnail: 'p17-thumbnail.webp',
        caption: 'A Warm Welcome to Our Honored Guests'
    },
    {
        id: 18,
        url: 'p18.webp',
        thumbnail: 'p18-thumbnail.webp',
        caption: 'Embracing Culture on Traditional Day'
    }

]
